export default __webpack_public_path__ + "assets/images/4cf122863f033f2aebc89e6143fe240c.svg";